export var BaseTimeType;
(function (BaseTimeType) {
    BaseTimeType["ORIGINAL_CREATED_AT"] = "original_created_at";
    BaseTimeType["SETTLED_AT"] = "settled_at";
    BaseTimeType["GAME_START_AT"] = "game_start_at";
    BaseTimeType["ACCOUNTED_AT"] = "accounted_at";
})(BaseTimeType || (BaseTimeType = {}));
//# sourceMappingURL=BaseTimeType.js.map